module.exports = __webpack_public_path__ + "img/about-before.a4a98f34.svg";